import { render, staticRenderFns } from "./BillsView.vue?vue&type=template&id=6e71c19a&scoped=true&"
import script from "./BillsView.vue?vue&type=script&lang=ts&"
export * from "./BillsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e71c19a",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\javie\\Documents\\Javier\\Developer\\Landing Dayco\\dayco-cportal-app-client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e71c19a')) {
      api.createRecord('6e71c19a', component.options)
    } else {
      api.reload('6e71c19a', component.options)
    }
    module.hot.accept("./BillsView.vue?vue&type=template&id=6e71c19a&scoped=true&", function () {
      api.rerender('6e71c19a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/invoicing/views/BillsView.vue"
export default component.exports